import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { SelectionType, ColumnMode } from '@swimlane/ngx-datatable';
import { IMyDpOptions } from 'mydatepicker';
import { BookingsService } from '../bookings.service';
import { Booking } from './../addbooking/booking.interface';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { state } from '@angular/animations';
import * as moment from "moment";
import { ThemeSetting } from '../../../pages/users/users.model';
import { LocalStorage } from 'ngx-store';
import { Url } from '../../users/users.model';
import { NotificationService } from '../../../services/notification.service';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { formatDate } from '@angular/common';

//Model
import { FileExport } from '../../../model/exporter.model';
import { Invoice } from './../../invoices/invoice.interface';
import { User } from '../../../model/users.model';

/*** Export List Feature Imports ***/
import { ExportService } from './../../../services/exporter.service';
import { DataService } from '../../../services/data.service';
import { InvoicesService } from './../../../services/invoices.service';
import { DispatchService } from 'src/app/services/dispatch.service';
import { saveAs } from 'file-saver';
import { PrintService } from './../../../services/print.service';
import { ComponentsSettingsService} from '../../../services/components_settings.service';


@Component({
  selector: 'app-connotelist',
  templateUrl: './connotelist.component.html',
  styleUrls: ['./connotelist.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [BookingsService, NotificationService , InvoicesService, DispatchService]
})


export class ConnoteListComponent implements OnInit {
  @LocalStorage() url: Url;
  @LocalStorage() themeSettings: ThemeSetting;
  @LocalStorage() user: User;

  @ViewChild('modalMarkJobForInvoicing', { static: false}) modalMarkJobForInvoicing: TemplateRef<any>;
  @ViewChild('modalAccept', {static: false}) modalAccept: TemplateRef<any>;
  @ViewChild('modalAcceptCreate', {static: false}) modalAcceptCreate: TemplateRef<any>;
  @ViewChild('modalCancelJob', {static: false}) modalCancelJob: TemplateRef<any>;
  @ViewChild('connotesTable', {static: false}) table: any;


  connotes = [];
  temp = [];
  states: any = [];
  selected: any = [];
  selected_bulk_accept: any = [];
  bulk_count: number = 0;
  fullRows = [];
  loadingIndicator: boolean = true;
  statusDropdown: string = 'all';
  dateDropdown: string = 'week';
  spinner: boolean = false;
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  filterStatus: string = '';
  filterJobType: string = '';
  isFilterEmpty: boolean = true;

  totalItems: number = 0;
  totalPrice: number = 0;
  totalChangeover: number = 0;
  totalLinehaul: number = 0;
  totalLocal: number = 0;
  totalEmptyRun: number = 0;
  totalTowhaul: number = 0;
  totalTrailerHire: number = 0;
  
  count: number = 0;

  public jobDateRange: any = [];
  public jobType:any = [];
  public serviceType:any = []; 

  public charging_methods = [
    {id:1, name:'Tonne'},
    {id:2, name:'Pallets'},
    {id:3, name:'Load'},
    {id:4, name:'Hourly'},
    {id:5, name:'Distance'}
  ]

  public locale: any = {
    format: 'DD MMMM YYYY',
    displayFormat: 'DD MMMM YYYY',
    separator: ' to ',
    cancelLabel: 'Cancel',
    applyLabel: 'OK',
  }
  maxDate: moment.Moment = moment();
  showFilters: boolean = false;

  //Handles the name, type and content of the to-be exported file
  public exp_excel: FileExport;
  public exp_pdf: FileExport;
  //Stores the filtered and formatted content of the file
  formatted_list: any;

  //Connote Column Filters
  public showConnoteWeek: boolean = true;
  public showStartDate: boolean = true;
  public showCustomer: boolean = true;
  public showCustomerRef: boolean = true;
  public showControlNo: boolean = true;
  public showType: boolean = false;
  public showChargingMethod: boolean = false;
  public showPrice: boolean = false;
  public showServiceFee: boolean = false;
  public showFuelLevy: boolean = false;
  public showServiceType: boolean = false;
  public showPickup: boolean = true;
  public showDelivery: boolean = true;
  public showDrivers: boolean = true;
  public showEquipments: boolean = true;
  public showPickupDatetime: boolean = true;
  public showDeliveryDatetime: boolean = true;

  //Filter Content in Specified Column
  public filterStartDate: string = '';
  public filterCustomer: string = '';
  public filterCustomerRef: string = '';
  public filterControlNo: string = '';
  public filterType: string = '';
  public filterChargingMethod: string = '';
  public filterPrice: string = '';
  public filterServiceFee: string = '';
  public filterFuelLevy: string = '';
  public filterServiceType: string = '';
  public filterPickups: string = '';
  public filterDeliveries: string = '';
  public filterDrivers: string = '';
  public filterEquipments: string = '';
  public filterConnoteWeek: string = '';
  
  //Print Logo
  public titleLogoURL: string;

  public modalRef: NgbModalRef;
  currentId: number;

  getConnotesService = null;

  constructor(private _fb: FormBuilder, private bookingsService: BookingsService, private toastr: ToastrService, private router: Router, 
    private exporter: ExportService, private svc_toaster: NotificationService, public _invoicesService: InvoicesService, private http: HttpClient,
    private modal: NgbModal, private dispatchService: DispatchService, public printer: PrintService, private svc_components : ComponentsSettingsService) {
    this.titleLogoURL = this.url.rest + '/images/title_logo.jpg';
  }

  ngOnInit(): void {

    this.getConnotes();

    //Declaration to handle the name, type and content of the file
    this.exp_excel = { title: '', list_data: '', type: '' };
    this.exp_pdf = { title: '', list_data: '', type: '' };
    this.resetBulkAcceptVariables();
  }

  ngOnDestroy(){
    if(this.getConnotesService != null){
      this.getConnotesService.unsubscribe();
      this.getConnotesService = null;
    }
  }

  gotoConnotesv2(){
    this.router.navigate(['/bookings/connotesv2']);
  }

  resetBulkAcceptVariables(){
    //reset bulk select variables
    this.selected_bulk_accept = [];
    this.bulk_count = 0;
  }

  gotoAddBookingPage() {
    this.router.navigate(['bookings/add']);
  }

  hasPointDone(str: string) {
    if (str)
      return str.includes('fa-check');
    else return false;
  }

  getCopy(str: string) {
    var newStr = str.replace(/<br\s*[\/]?>/gi, "\n");
    newStr = newStr.replace('<i class="fa fa-check"></i>','');
    return newStr;
  }

  getConnotes(statusFilter = this.statusDropdown, dateFilter = this.dateDropdown, start = '', end = '') {
    this.loadingIndicator = true;
    this.getConnotesService = this.bookingsService.getConnotes(statusFilter, dateFilter, start, end).subscribe(data => {
      this.connotes = data['connotes'];//console.log(this.connotes);
      
      this.selected = [];
      if (data['connotes'].length > 0){
        this.selected = [data['connotes'][0]];
      }else{
        this.selected = [];
      };

      if(statusFilter== 'completed'){
        this.selected = [];
      }
      
      this.states = data['states'];
      this.fullRows = this.connotes;

      // this.getchargingmethod();
      this.computeSummary();
      this.resetFilters();
      this.getmiscData();
      this.count = Object.keys(this.connotes).length;

      setTimeout(() => { this.loadingIndicator = false; }, 1000);

    });
  }

  // getchargingmethod(){
  //   this.connotes.forEach(con=>{
  //     let temp = this.charging_methods.find(x=>x.id == con.charging_method_id)?.name
  //     con['charging_method'] = temp;
  //   })
  // }
  
  async getmiscData(){
    await this.dispatchService.getDispatchMiscData().toPromise().then(data => {
      this.jobType = data['run_types'];
      this.serviceType = data['service_types'];

      this.connotes.forEach(con=>{
        let jt = this.jobType.find(x=>x.id == con.run_type_id);
        let st = this.serviceType.find(x=>x.id == con.service_type_id);
        con['job_type'] = jt.label;

        if(st){
          con['service_type'] = st.name;
        }else{
          con['service_type'] = '';
        }
        
      })
    });
  }

  showConnotesPage() {
    this.router.navigate(['bookings/list']);
  }

  getCellClass({ row }): any {
    return {
      'is-connote-pending': row.run_status_id == 1,
      'is-connote-dispatched': row.run_status_id == 2,
      'is-connote-processing': row.run_status_id == 3,
      'is-connote-completed': row.run_status_id == 4,
      'is-connote-cancelled': row.run_status_id == 5,
      // 'is-withdrawn': row.is_assigned == '0' && row.is_enabled == '0',
      // 'is-subcontracted': row.is_assigned == '0' && row.is_enabled == '0',
      // 'is-draft': row.is_assigned == '0' && row.is_enabled == '0',

    };
  }

  onSelect({ selected }) {
    //console.log('Select Event', selected, this.selected);
    if(selected != undefined){
      this.selected = selected;
    }else{
      this.selected = [];
    }
    
  }

  onActivate(event) {
   /*  console.log('Activate Event', event);
    if (event.type === 'mouseenter') {
      this.selected[0] = event.row;
    } */
  }


  onClickStatus(status) {
    this.filterStatus = status;
    this.updateFilter();
    this.computeSummary();

    if(status == 'Completed'){
      this.sType =  this.SelectionType.checkbox;
      this.selected = [];
    }else{
      this.sType =  this.SelectionType.single;
    }
  }

  onClickJobType(type) {
    this.filterType = type;
    this.updateFilter();
    this.computeSummary();

  }

  updateFilter() {
    // this.isFilterEmpty = false;
    this.temp = this.fullRows;

    if (this.filterConnoteWeek) {
      this.temp = this.temp.filter(data => {
        if (data.connote_week)
          return data.connote_week.toLowerCase().indexOf(this.filterConnoteWeek.toLowerCase()) !== -1 || !this.filterConnoteWeek.toLowerCase();
        else return data.connote_week;
      });
    }

    if (this.filterCustomerRef) {
      this.temp = this.temp.filter(data => {
        if (data.customer_reference_no)
          return data.customer_reference_no.toLowerCase().indexOf(this.filterCustomerRef.toLowerCase()) !== -1 || !this.filterCustomerRef.toLowerCase();
        else return data.customer_reference_no;
      })
    }

    if (this.filterCustomer) {
      this.temp = this.temp.filter(data => {
        if (data.customer)
          return data.customer.toLowerCase().indexOf(this.filterCustomer.toLowerCase()) !== -1 || !this.filterCustomer.toLowerCase();
        else return data.customer;
      })
    }

    if (this.filterControlNo) {
      this.temp = this.temp.filter(data => {
        if (data.control_no)
          return data.control_no.toLowerCase().indexOf(this.filterControlNo.toLowerCase()) !== -1 || !this.filterControlNo.toLowerCase();
        else return data.control_no;
      })
    }

    if (this.filterType) {
      this.temp = this.temp.filter(data => {
        if (data.job_type){
          if(this.filterType == 'Changeover'){
            return data.run_changeover !=null;
          } else return data.job_type.toLowerCase().indexOf(this.filterType.toLowerCase()) !== -1 || !this.filterType.toLowerCase();
        } else return data.job_type;
      })
    }

    
    if (this.filterStatus) {
      this.temp = this.temp.filter(data => {
        if (data.run_status_id)
          return data.status.toLowerCase().indexOf(this.filterStatus.toLowerCase()) !== -1 || !this.filterStatus.toLowerCase();
        else return data.status;
      });
    }

    if (this.filterChargingMethod) {
      this.temp = this.temp.filter(data => {
        let renamed_charging_method = data.charging_method
        if(data.charging_method == 'Pallets'){
          renamed_charging_method = 'Freight Packaging';
        }
        if (renamed_charging_method)
          return renamed_charging_method.toLowerCase().indexOf(this.filterChargingMethod.toLowerCase()) !== -1 || !this.filterChargingMethod.toLowerCase();
        else return renamed_charging_method;
      })
    }
   
    if (this.filterPrice) {
      this.temp = this.temp.filter(data => {
        if (data.price){
          let price = data.price.toString();
          return price.toLowerCase().indexOf(this.filterPrice.toLowerCase()) !== -1 || !this.filterPrice.toLowerCase();
        }
        else return data.price;
      })
    }

    if (this.filterServiceFee) {
      this.temp = this.temp.filter(data => {
        if (data.service_fee){
          let fee = data.service_fee.toString();
          return fee.toLowerCase().indexOf(this.filterServiceFee.toLowerCase()) !== -1 || !this.filterServiceFee.toLowerCase();
        }else return data.service_fee;
      })
    }

    if (this.filterFuelLevy) {
      this.temp = this.temp.filter(data => {
        if (data.fuel_levy){
          let levy = data.fuel_levy.toString();
          return levy.toLowerCase().indexOf(this.filterFuelLevy.toLowerCase()) !== -1 || !this.filterFuelLevy.toLowerCase();
        }
        else return data.fuel_levy;
      })
    }

    if (this.filterServiceType) {
      this.temp = this.temp.filter(data => {
        if (data.service_type)
          return data.service_type.toLowerCase().indexOf(this.filterServiceType.toLowerCase()) !== -1 || !this.filterServiceType.toLowerCase();
        else return data.service_type;
      })
    }

    if (this.filterPickups) {
      // console.log("TBA", this.filterPickups);
      this.temp = this.temp.filter(data => {
        if (data.pickups)
          return data.pickups.toLowerCase().indexOf(this.filterPickups.toLowerCase()) !== -1 || !this.filterPickups.toLowerCase();
        else if (this.filterPickups.toLocaleLowerCase() == 't' || this.filterPickups.toLocaleLowerCase() == 'tb' || this.filterPickups.toLocaleLowerCase() == 'tba')
          return data.pickups == '';
        else
          return data.pickups;
      })
    }

    if (this.filterDeliveries) {
      this.temp = this.temp.filter(data => {
        if (data.deliveries)
          return data.deliveries.toLowerCase().indexOf(this.filterDeliveries.toLowerCase()) !== -1 || !this.filterDeliveries.toLowerCase();
        else if (this.filterDeliveries.toLocaleLowerCase() == 't' || this.filterDeliveries.toLocaleLowerCase() == 'tb' || this.filterDeliveries.toLocaleLowerCase() == 'tba')
          return data.deliveries == '';
        else return data.deliveries;
      })
    }

    if (this.filterEquipments) {
      this.temp = this.temp.filter(data => {
        if(data.run_status_id == 1){
          if (data.booking_fleet)
            return data.booking_fleet.toLowerCase().indexOf(this.filterEquipments.toLowerCase()) !== -1 || !this.filterEquipments.toLowerCase();
          else return data.booking_fleet;
        }
        
        if(data.run_status_id > 1){
          if (data.dispatch_equipments)
            return data.dispatch_equipments.toLowerCase().indexOf(this.filterEquipments.toLowerCase()) !== -1 || !this.filterEquipments.toLowerCase();
          else return data.dispatch_equipments;
        }
      })
    }

    if (this.filterDrivers) {
      this.temp = this.temp.filter(data => {
        if(data.run_status_id == 1){
          if (data.booking_drivers)
            return data.booking_drivers.toLowerCase().indexOf(this.filterDrivers.toLowerCase()) !== -1 || !this.filterDrivers.toLowerCase();
          else return data.booking_drivers;
        }
        
        if(data.run_status_id > 1){
          if (data.dispatch_drivers)
            return data.dispatch_drivers.toLowerCase().indexOf(this.filterDrivers.toLowerCase()) !== -1 || !this.filterDrivers.toLowerCase();
          else return data.dispatch_drivers;
        }
      })
    }


    this.connotes = this.temp;
    this.computeSummary();
    
    if(this.temp.length){
      this.count = this.temp.length;
    }else{
      this.count = 0;
    }
    
  }


  resetFilters() {
    this.connotes = this.fullRows;
    this.computeSummary();

    if(this.fullRows?.length){
      this.count = this.fullRows?.length
    }else{
      this.count = 0;
    };

    this.isFilterEmpty = true;

    this.filterStatus = '';
    this.filterStartDate = '';
    this.filterCustomer = '';
    this.filterCustomerRef = '';
    this.filterControlNo = '';
    this.filterType = '';
    this.filterChargingMethod = '';
    this.filterPrice = '';
    this.filterServiceFee = '';
    this.filterFuelLevy = '';
    this.filterServiceType = '';
    this.filterPickups = '';
    this.filterDeliveries = '';
    this.filterDrivers = '';
    this.filterEquipments = '';
    this.filterConnoteWeek = '';
  }

  computeSummary() {
    this.totalItems = 0;
    this.totalPrice = 0;
    this.totalChangeover = 0;
    this.totalLinehaul = 0;
    this.totalLocal = 0;
    this.totalEmptyRun = 0;
    this.totalTowhaul = 0;
    this.totalTrailerHire = 0;
    
    if (this.connotes[0]) {
      let sumDistance: number = this.connotes.map(a => parseFloat(a.total_distance)).reduce(function (a, b) {
        return a + b;
      });
      
      this.totalItems = this.connotes.length;
      
      //this.rows.reduce((counter, {job_type_id}) => job_type_id == 1 ? this.totalLocal + 1 : this.totalLocal, 0);
      for (const input of this.connotes) {
        if (input.run_type_id == 1) this.totalLocal = this.totalLocal + 1;
      }

      for (const input of this.connotes) {
        if (input.run_type_id == 2) this.totalLinehaul = this.totalLinehaul + 1;
      }

      for (const input of this.connotes) {
        if (input.run_type_id == 3) this.totalEmptyRun = this.totalEmptyRun + 1;
      }

      for (const input of this.connotes) {
        if (input.run_type_id == 4) this.totalTowhaul = this.totalTowhaul + 1;
      }

      for (const input of this.connotes) {
        if (input.run_type_id == 5) this.totalTrailerHire = this.totalTrailerHire + 1;
      }

      for (const input of this.connotes) {
        if(input.run_changeover != null) this.totalChangeover = this.totalChangeover + 1;
      }

      for (const input of this.connotes) {console.log();
        if(input.status != 'Cancelled'){
          this.totalPrice = this.totalPrice + this.getAmount(input);
        }
      }
    } 
    //this.averagePrice = (this.totalPrice / this.totalItems) || 0;
  }


  /*** Export... Module ***/
  //Replaces an attribute name for reading comprehension
  renameKey(obj, oldKey, newKey) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //Formats readable header names in the given table
  Jobs_generateHeaders(list_currentJobs): any {
    const arr = JSON.parse(list_currentJobs);
    arr.forEach(obj => {
      this.renameKey(obj, 'connote_week', 'Connote Week');
      this.renameKey(obj, 'start_datetime', 'Start Date');
      this.renameKey(obj, 'customer_reference_no', 'Reference #');
      this.renameKey(obj, 'customer', 'Customer');
      this.renameKey(obj, 'control_no', 'Job Control #');
      this.renameKey(obj, 'job_type', 'Job Type');
      this.renameKey(obj, 'charging_method', 'Charge by');
      this.renameKey(obj, 'price', 'Price');
      this.renameKey(obj, 'service_fee', 'Service Fee');
      this.renameKey(obj, 'fuel_levy', 'Fuel Levy');
      this.renameKey(obj, 'service_type', 'Service Type');
      this.renameKey(obj, 'pickups', 'Start/Pickup Location');
      this.renameKey(obj, 'deliveries', 'End/Delivery Location');
      this.renameKey(obj, 'pickup_datetime', 'Start/Pickup Date');
      this.renameKey(obj, 'delivery_datetime', 'End/Delivery Date');
      this.renameKey(obj, 'booking_fleet', 'Fleet');
      this.renameKey(obj, 'booking_drivers', 'Drivers');
    });
    const updatedJson = JSON.stringify(arr);
    return updatedJson;
  }

  //Filters every column in the Current Jobs table list
  currentJobs_generateColumnsWithFilter(list_currentJobs) {
    const arr = JSON.parse(JSON.stringify(list_currentJobs));
    arr.forEach(obj => {
      if (obj['customer'] == null) obj['customer'] = '-';
      if (obj['service_fee'] == null || obj['service_fee'] == 0) obj['service_fee'] = '-';

      if (obj['fuel_levy'] == null || obj['fuel_levy'] == 0) obj['fuel_levy'] = '-';
      else obj['fuel_levy']= obj['fuel_levy'] + '%';

      if (obj['customer_reference_no'] == null) obj['customer_reference_no'] = '-';
      if (obj['price'] == null) obj['price'] = '$0';
      else obj['price'] = '$' + obj['price'];

      if (obj['pickups'] == null || obj['pickups'] == '') obj['pickups'] = 'TBA';
      if (obj['deliveries'] == null || obj['deliveries'] == '') obj['deliveries'] = 'TBA';

      if (obj['run_status_id'] > 1 && obj['dispatch_equipments'] != ''){
        obj['booking_fleet'] = obj['dispatch_equipments'];
      }

      if (obj['run_status_id'] > 1 && obj['dispatch_drivers'] != ''){
        obj['booking_drivers'] = obj['dispatch_drivers'];
      }

      if (obj['start_datetime'] == '0000-00-00 00:00:00' || obj['start_datetime'] == null)
        obj['start_datetime'] = 'No Date';
      else
        obj['start_datetime'] = formatDate(obj['start_datetime'], 'dd MMM yyyy', 'en_US');

      if (obj['pickup_datetime'] == '0000-00-00 00:00:00' || obj['pickup_datetime'] == null || obj['pickup_datetime'] == '')
        obj['pickup_datetime'] = 'No Date';
      else
        obj['pickup_datetime'] = formatDate(obj['pickup_datetime'], ' dd MMM yyyy h:mm a', 'en_US');

      if (obj['delivery_datetime'] == '0000-00-00 00:00:00' || obj['delivery_datetime'] == null || obj['delivery_datetime'] == '')
        obj['delivery_datetime'] = 'No Date';
      else
        obj['delivery_datetime'] = formatDate(obj['delivery_datetime'], ' dd MMM yyyy h:mm a', 'en_US');

      //remove filtered columns
      if (!this.showConnoteWeek) {
        delete obj['connote_week'];
      };
      if (!this.showStartDate) {
        delete obj['start_datetime'];
      };
      if (!this.showCustomer) {
        delete obj['customer'];
      };
      if (!this.showControlNo) {
        delete obj['control_no'];
      };
      if (!this.showPickup) {
        delete obj['pickups'];
      };
      if (!this.showDelivery) {
        delete obj['deliveries'];
      };
      if (!this.showPickupDatetime) {
        delete obj['pickup_datetime'];
      };
      if (!this.showDeliveryDatetime) {
        delete obj['delivery_datetime'];
      };
      if(!this.showEquipments){
        delete obj['booking_fleet'];
      };
      if(!this.showDrivers){
        delete obj['booking_drivers'];
      };

      if(!this.showCustomerRef){
        delete obj['customer_reference_no'];
      };

      if(!this.showType){
        delete obj['job_type'];
      };

      if(!this.showPrice){
        delete obj['price'];
      };

      if(!this.showServiceFee){
        delete obj['service_fee'];
      };

      if(!this.showServiceType){
        delete obj['service_type'];
      };

      if(!this.showFuelLevy){
        delete obj['fuel_levy'];
      };

      if(!this.showChargingMethod){
        delete obj['charging_method'];
      };

      delete obj['invoice_id'];
      delete obj['id'];
      delete obj['customer_id'];
      delete obj['run_status_id'];
      delete obj['run_type_id'];
      delete obj['pickups_full'];
      delete obj['deliveries_full'];
      delete obj['dispatch_drivers'];
      delete obj['dispatch_equipments'];
      delete obj['status'];
      delete obj['is_invoiced'];
      delete obj['is_invoice_ready'];
      delete obj['tonnes'];
      delete obj['pallet'];
      delete obj['charging_method_id'];
      delete obj['service_type_id'];
      delete obj['loads'];
      delete obj['run_id'];
      delete obj['sdp_file'];
      delete obj['files'];
      delete obj['run_changeover'];
      delete obj['arrival_date'];
      delete obj['year'];
      delete obj['month'];
      delete obj['week_no'];
      delete obj['est_total_hours'];
      delete obj['total_klms'];
      delete obj['total_cost'];
      delete obj['other_cost'];
      delete obj['trailer_hire_start'];
      delete obj['trailer_hire_end'];
      delete obj['changeover_flag'];
      delete obj['changeover_partial_flag'];
      
    });
    const updatedJson = JSON.stringify(arr);
    return updatedJson;
  }

  //Exports Current Jobs table to CSV file
  connote_exportToCSV() {
    if (this.connotes.length > 0) {
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.currentJobs_generateColumnsWithFilter(this.connotes);

      //generate json with format header
      this.formatted_list = this.Jobs_generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();

      if (this.statusDropdown == 'current') {
        let csv_file = '[TMS]Current_Connote_List_' + this.formattedDate(current_date);
        this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Jobs - Current Jobs List');
      } else if (this.statusDropdown == 'completed') {
        let csv_file = '[TMS]Completed_Connote_List_' + this.formattedDate(current_date);
        this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Jobs - Completed Jobs List');
      } else if (this.statusDropdown == 'forinvoice') {
        let csv_file = '[TMS]For_Invoice_Connote_List_' + this.formattedDate(current_date);
        this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Jobs - For Invoice Jobs List');
      } else if (this.statusDropdown == 'archived') {
        let csv_file = '[TMS]Archived_Connote_List_' + this.formattedDate(current_date);
        this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Jobs - Archived Jobs List');
      } if (this.statusDropdown == 'all') {
        let csv_file = '[TMS]All_Connote_List_' + this.formattedDate(current_date);
        this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Jobs - All Jobs List');
      }
    }
  };

  //Exports Current Jobs table to PDF file
  connote_exportToPDF() {
    if (this.connotes.length > 0) {
      let with_header_format, with_column_filter, pdf_file;

      //generate json with filtered column
      with_column_filter = this.currentJobs_generateColumnsWithFilter(this.connotes);

      //generate json with format header
      this.formatted_list = this.Jobs_generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      if (this.statusDropdown == 'current') {
        pdf_file = '[TMS]Current_Connote_List_' + this.formattedDate(current_date);
        this.exp_pdf.title = 'CURRENT CONNOTE LIST';
      } else if (this.statusDropdown == 'completed') {
        pdf_file = '[TMS]Completed_Connote_List_' + this.formattedDate(current_date);
        this.exp_pdf.title = 'COMPLETED CONNOTE LIST';
      } else if (this.statusDropdown == 'forinvoice') {
        pdf_file = '[TMS]For_Invoice_Connote_List_' + this.formattedDate(current_date);
        this.exp_pdf.title = 'FOR INVOICE CONNOTE LIST';
      } else if (this.statusDropdown == 'archived') {
        pdf_file = '[TMS]Archived_Connote_List_' + this.formattedDate(current_date);
        this.exp_pdf.title = 'ARCHIVED CONNOTE LIST';
      } else if (this.statusDropdown == 'all') {
        pdf_file = '[TMS]All_Connote_List_' + this.formattedDate(current_date);
        this.exp_pdf.title = 'ALL CONNOTE LIST';
      }

      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data => {
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  //Exports Current Jobs table to MS Excel file
  connote_exportToExcel() {
    if (this.connotes.length > 0) {
      let with_header_format, with_column_filter, excel_file;

      //generate json with filtered column
      with_column_filter = this.currentJobs_generateColumnsWithFilter(this.connotes);

      //generate json with format header
      this.formatted_list = this.Jobs_generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      if (this.statusDropdown == 'current') {
        excel_file = '[TMS]Current_Connote_List_' + this.formattedDate(current_date);
        this.exp_excel.title = 'CURRENT CONNOTE LIST';
      } else if (this.statusDropdown == 'completed') {
        excel_file = '[TMS]Completed_Connote_List_' + this.formattedDate(current_date);
        this.exp_excel.title = 'COMPLETED CONNOTE LIST';
      } else if (this.statusDropdown == 'forinvoice') {
        excel_file = '[TMS]For_Invoice_Connote_List_' + this.formattedDate(current_date);
        this.exp_excel.title = 'FOR INVOICE JOBS LIST';
      } else if (this.statusDropdown == 'archived') {
        excel_file = '[TMS]Archived_Connote_List_' + this.formattedDate(current_date);
        this.exp_excel.title = 'ARCHIVED CONNOTE LIST';
      } else if (this.statusDropdown == 'all') {
        excel_file = '[TMS]All_Connote_List_' + this.formattedDate(current_date);
        this.exp_excel.title = 'ALL CONNOTE LIST';
      }

      this.exp_excel.type = 'xlsx';
      this.exp_excel.list_data = this.formatted_list;
      this.exporter.exportToExcel(this.exp_excel).subscribe(data => {

        saveAs(data, excel_file)

        //var xlsx_file = new File(data, excel_file, {type: 'xlsx'});
        //saveAs(xlsx_file);

      });
    }
  };

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return `${day}/${month}/${year}`;
  }

  public toggleFilters() {
    if (this.showFilters) this.showFilters = false;
    else this.showFilters = true;
  }

  sType: any = this.SelectionType.single;
  onChangeStatusDropdown(selected) {
    this.statusDropdown = selected;
    this.loadingIndicator = true;
    console.log(this.statusDropdown, this.dateDropdown);
    if (selected) {
        if (selected == 'completed') this.dateDropdown = '7';
        if (selected == 'current') this.dateDropdown = 'all';
        if (selected == 'forinvoice') this.dateDropdown = 'all';
        if (selected == 'archived') this.dateDropdown = '7';
        if (selected == 'all') this.dateDropdown = '7';
        this.getConnotes(selected, this.dateDropdown);
    }

    if(selected == 'completed'){
      this.sType =  this.SelectionType.checkbox;
      this.selected = [];
    }else{
      this.sType =  this.SelectionType.single;
    }
  }

  onChangeDateDropdown(selected) {
    console.log(this.statusDropdown, this.dateDropdown);
    if (selected != 'range') {
        this.loadingIndicator = true;

        this.getConnotes(this.statusDropdown, selected);
    }
  }

  processDateRange() {
    var start = moment(this.jobDateRange.start?._d).format('YYYY-MM-DD');
    var end = moment(this.jobDateRange.end?._d).format('YYYY-MM-DD');
    console.log(start + ' to ' + end);
    this.getConnotes(this.statusDropdown,'range',start, end);
  }

  markCreateInvoice(job_id, rJob){
    let params = this.convertToJSON(rJob);
    this.http.get(this.url.rest + '/tms/markJobForInvoicing/' + job_id + '/' + this.user.id).subscribe(data => {
      if(data['success']){
        this.router.navigate(["/invoices/create", params]);
      }else{
        this.svc_toaster.showError("There was an error in marking the job for invoicing.", "Marking Invoice Error");
      };
      
    });
   
  }

  composeInvoice(row){
    let params = this.convertToJSON(row);
    this.router.navigate(["/invoices/create", params]);
  }

  getCheckboxStatus({ row, column, value }): any {
    let rCheckbox = false;
      if(row.is_invoiced==0 && row.job_status_id==4 && row.is_invoice_ready == 0 && row.is_empty_run==0){
        rCheckbox = true;
      };
      console.log(rCheckbox);
      return rCheckbox
  }

  openAccept(){
    this.modalRef = this.modal.open(this.modalAccept, {container: '.app', backdrop: 'static', size: 'md'});
    if(this.selected.length){
      this.selected.forEach(item=>{
        if(item.is_invoiced==0 && item.run_status_id==4 && item.is_invoice_ready == 0 && item.run_type_id!=3){
          this.selected_bulk_accept.push(item);
        }
      })
      if(this.selected_bulk_accept.length){
        this.bulk_count = this.selected_bulk_accept.length;
      }
    }else{
      this.bulk_count = 0;
    }
  }

  json_string: string;
  openAcceptCreate(){
    var arr = [];
    this.selected_bulk_accept.forEach((myObject, index) => {
      arr.push(myObject.id);
    });
    this.json_string = JSON.stringify(arr);
    this.router.navigate(['invoices/create/' + this.json_string]);
  }

  bulkAccept(){
    this.bookingsService.bulkMarkForInvoice(this.selected_bulk_accept, this.user.id).subscribe(data=>{
      if(data['error']== false){
        this.svc_toaster.showSuccess(data['message'], '');
      }else{
        this.svc_toaster.showError(data['message'], '');
      };

      this.getConnotes();
    })

    this.modalRef.close();
    this.resetBulkAcceptVariables();
  }

  convertToJSON(value) {
    var car = [];
    car.push(value);
    return JSON.stringify(car);
  }

  openModalMarkForInvoice(row): void {
    console.log('opening modal to mark invoice');
    //this.currentControlNo = controlNo;
    this.currentId = row.id;
    this.selected = [row];
    this.modalRef = this.modal.open(this.modalMarkJobForInvoicing, {container: '.app', backdrop: 'static'});
  }

  generateButton(job){
    
    let amount = 0;
    amount = this.getAmount(job);
    //console.log(amount);
    if(amount>0){
      return false;
    }else{
      return true;
    }
  }

  // start invoice immediate create in accept and send
  jobs_for_invoice =[]
  invoiceBanks = [];
  chargingMethods2: any;
  public myForm: FormGroup;

  public acceptAndSend(job){
    //console.log(job);
    let job_id = '[' + job.id + ']';
    this._invoicesService.getInvoiceJobDetails(job_id).subscribe(data => {
      this.jobs_for_invoice = data['jobs'];
      this.invoiceBanks = data['invoice_banks']

      this.myForm = this._fb.group({
        isJob: [false],
        customer_id: [this.jobs_for_invoice[0]['customer_id']],
        due_date: [this.jobs_for_invoice[0]['due_date']],
        payment_option_id: [this.jobs_for_invoice[0]['invoice_bank_id']],
        jobs: this._fb.array([this.initJob()]),
        total_amount: ['0'],
        subtotal:['0'],
        gst: ['0'],
        grand_total: ['0']
      });
      console.log('Form Initialized...')

      if (this.jobs_for_invoice.length > 0) {
        this.initJobs();
      }
      //console.log(this.myForm.value);

      if(this.myForm.valid == true){
        this.onSaveInvoice(this.myForm.value);
      }
      
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
    });

  }

  initJob() {
    const currencyRegex = '^(?!0+(?:\.0+)?$)(?:999|999.0|999.00|[0-9]{1,6}(?:\.[0-9]{1,2})?)$';
    // initialize our job
    return this._fb.group({
      job_id: [''],
      date: [''],
      day: [''],
      charging_method_id: [''],
      charging_method: [''],
      details: [''],
      manifest_connote_no: [''],
      job_type: ['Local'],
      units: [''],
      price: ['0'],
      fuel_levy: ['0'],
      fuel_levy_cost: ['0'],
      fuel_levy_cost_formatted: ['0'],
      service_fee: ['0'],
      service_fee_cost: ['0'],
      service_fee_cost_formatted: [''],
      total_extras: ['0'],
      amount: ['', [Validators.required, Validators.pattern(currencyRegex)]],
      hand_unload: ['0'],
      tail_lift: ['0'],
      overnight_holding: ['0'],
      after_hours: ['0'],
      trailer_split: ['0'],
      futile: ['0'],
      residential_charge: ['0'],
      extra_site: ['0'],
      dg: ['0'],
      dg_details: [''],
      extra_crew: ['0'],
      arrival_date: ['0'],
      demurrage: ['0'],
      toll_cost: ['0'],
      add_on_choice: ['0'],

      is_hand_unload: [false],
      is_tail_lift: [false],
      is_overnight_holding: [false],
      is_after_hours: [false],
      is_trailer_split: [false],
      is_futile: [false],
      is_residential_charge: [false],
      is_extra_site: [false],
      is_dg: [false],
      is_extra_crew: [false],
      is_toll_cost: [false],
      is_demurrage: [false]
    });

  }

  initJobs() {
    const fCtrl = (<any>this.myForm);
    const jCtrl = fCtrl.controls.jobs;
    this.jobs_for_invoice.forEach((myObject, index) => {
      if (index == 0)
        this.initValues(0);
      else {
        jCtrl.push(this.initJob());
        this.initValues(index);
      }

    });
  }

  initValues(i: number) {
    const fCtrl = (<any>this.myForm);
    const jCtrl = fCtrl.controls.jobs.controls[i];
    jCtrl.controls['job_id'].setValue(this.jobs_for_invoice[i].id);
    jCtrl.controls['date'].setValue(this.jobs_for_invoice[i].finished_date);
    jCtrl.controls['day'].setValue(this.jobs_for_invoice[i].finished_day);
    jCtrl.controls['details'].setValue(this.jobs_for_invoice[i].details);
    jCtrl.controls['manifest_connote_no'].setValue(this.jobs_for_invoice[i].manifest_connote_no);
    jCtrl.controls['job_type'].setValue(this.jobs_for_invoice[i].job_type);
    jCtrl.controls['charging_method_id'].setValue(this.jobs_for_invoice[i].charging_method_id);
    jCtrl.controls['charging_method'].setValue(this.jobs_for_invoice[i].charging_method);
    jCtrl.controls['units'].setValue(this.jobs_for_invoice[i].units);
    jCtrl.controls['price'].setValue(this.jobs_for_invoice[i].price);
    jCtrl.controls['fuel_levy'].setValue(this.jobs_for_invoice[i].fuel_levy);
    jCtrl.controls['service_fee'].setValue(this.jobs_for_invoice[i].service_fee);
    jCtrl.controls['arrival_date'].setValue(this.jobs_for_invoice[i].arrival_date);

    // init extras
    jCtrl.controls['hand_unload'].setValue(this.jobs_for_invoice[i].hand_unload);
    jCtrl.controls['tail_lift'].setValue(this.jobs_for_invoice[i].tail_lift);
    jCtrl.controls['residential_charge'].setValue(this.jobs_for_invoice[i].residential_charge);
    jCtrl.controls['extra_site'].setValue(this.jobs_for_invoice[i].extra_site);
    jCtrl.controls['trailer_split'].setValue(this.jobs_for_invoice[i].trailer_split);
    jCtrl.controls['extra_crew'].setValue(this.jobs_for_invoice[i].extra_crew);
    jCtrl.controls['after_hours'].setValue(this.jobs_for_invoice[i].after_hours);
    jCtrl.controls['overnight_holding'].setValue(this.jobs_for_invoice[i].overnight_holding);
    jCtrl.controls['futile'].setValue(this.jobs_for_invoice[i].futile);
    jCtrl.controls['demurrage'].setValue(this.jobs_for_invoice[i].demurrage);
    jCtrl.controls['toll_cost'].setValue(this.jobs_for_invoice[i].toll_cost);
    jCtrl.controls['dg'].setValue(this.jobs_for_invoice[i].dg);
    jCtrl.controls['dg_details'].setValue(this.getDGDetails(i));

    // init extras visibility
    jCtrl.controls['is_hand_unload'].setValue(this.jobs_for_invoice[i].is_hand_unload);
    jCtrl.controls['is_tail_lift'].setValue(this.jobs_for_invoice[i].is_tail_lift);
    jCtrl.controls['is_residential_charge'].setValue(this.jobs_for_invoice[i].is_residential_charge);
    jCtrl.controls['is_extra_site'].setValue(this.jobs_for_invoice[i].is_extra_site);
    jCtrl.controls['is_trailer_split'].setValue(this.jobs_for_invoice[i].is_trailer_split);
    jCtrl.controls['is_extra_crew'].setValue(this.jobs_for_invoice[i].is_extra_crew);
    jCtrl.controls['is_after_hours'].setValue(this.jobs_for_invoice[i].is_after_hours);
    jCtrl.controls['is_overnight_holding'].setValue(this.jobs_for_invoice[i].is_overnight_holding);
    jCtrl.controls['is_futile'].setValue(this.jobs_for_invoice[i].is_futile);
    jCtrl.controls['is_demurrage'].setValue(this.jobs_for_invoice[i].is_demurrage);
    jCtrl.controls['is_toll_cost'].setValue(this.jobs_for_invoice[i].is_toll_cost);
    jCtrl.controls['is_dg'].setValue(this.jobs_for_invoice[i].is_dg);

    fCtrl.controls['customer_id'].setValue(this.jobs_for_invoice[i].customer_id);
    fCtrl.controls['due_date'].setValue(this.jobs_for_invoice[i].due_date);

    // //amount
    // let amount, gst, subtotal, grand_total =0;
    // amount = this.getAmount(this.jobs_for_invoice[i]);
    // subtotal = amount + parseFloat(this.getTotalExtras(this.jobs_for_invoice[i]));
    // gst = (subtotal * .10);
    // grand_total = (subtotal + gst);
    
    // jCtrl.controls['amount'].setValue(amount);

    // fCtrl.controls['subtotal'].setValue(subtotal.toFixed(2));
    // fCtrl.controls['gst'].setValue(gst.toFixed(2));
    // fCtrl.controls['grand_total'].setValue(grand_total.toFixed(2));
  }

  getDGDetails(i: number) {
    var value: number;
    if (this.jobs_for_invoice[i].dg_goods == '1') {
      if (this.jobs_for_invoice[i].dg_type_id == '1')
        return "DG Goods - Packaged (10%)";
      else return "DG Goods - Bulk (20%)";
    }
    else return 'DG Goods';

  }

  getAmount(row){

    var units = 1, price = 0, amount = 0;
    if(row.total_cost > 0){
      amount = row.total_cost;
    }else{
      
      switch(row.charging_method_id){
        case 1 :{
          if(row.tonnes > 0){
            units = row.tonnes;
          }else{
            units = 1;
          };break;
        }

        case 2 :{
          if(row.pallet > 0){
            units = row.pallet;
          }else{
            units = 1;
          };break;
        }

        case 3 :{
          if(row.loads > 0){
            units = row.loads;
          }else{
            units = 1;
          };break;
        }

        case 4 :{
          if(row.total_work_hours > 0){
            units = row.total_work_hours;
          }else{
            units = 0;
          };break;
        }

        case 5 :{
          if(row.total_klms > 0){
            units = row.total_klms;
          }else{
            units = 0;
          };break;
        }

        default: {units = 0;break;}

      }
0
      var basicCost = units * row.price;
      var fuelLevyvalue = (parseFloat(row.fuel_levy) * basicCost) / 100;  // add fuel levy
      var serviceFeeValue = (parseFloat(row.service_fee) * basicCost) / 100;   // subtract service fee
      var amount = basicCost + fuelLevyvalue - serviceFeeValue;
  
    };

    
    return amount;
  }

  getDG(job) {
    var value: any;
    if (job.dg_goods == '1') {
      if (job.dg_type_id == '1')
        value = (this.getAmount(job) * 10) / 100;
      else value = (this.getAmount(job) * 20) / 100;
    }
    else value = 0.00;
    return value.toFixed(2);
  }

  getTotalExtras(job: any) {
    const ctrl = (<any>this.myForm);
    const jCtrl = (<any>this.myForm).controls.jobs.controls[0];
    var value = 0;

    if (job.is_dg)
      value = value + parseFloat(this.getDG(job));
    if (job.is_hand_unload)
      value = value + parseFloat(jCtrl.controls['hand_unload'].value);
    if (job.is_tail_lift)
      value = value + parseFloat(jCtrl.controls['tail_lift'].value);
    if (job.is_residential_charge)
      value = value + parseFloat(jCtrl.controls['residential_charge'].value);
    if (job.is_extra_site)
      value = value + parseFloat(jCtrl.controls['extra_site'].value);
    if (job.is_trailer_split)
      value = value + parseFloat(jCtrl.controls['trailer_split'].value);
    if (job.is_extra_crew)
      value = value + parseFloat(jCtrl.controls['extra_crew'].value);
    if (job.is_after_hours)
      value = value + parseFloat(jCtrl.controls['after_hours'].value);
    if (job.is_demurrage)
      value = value + parseFloat(jCtrl.controls['demurrage'].value);
    if (job.is_overnight_holding)
      value = value + parseFloat(jCtrl.controls['overnight_holding'].value);
    if (job.is_futile)
      value = value + parseFloat(jCtrl.controls['futile'].value)
    if (job.is_toll_cost)
      value = value + parseFloat(jCtrl.controls['toll_cost'].value)


    return value.toFixed(2);
  }

 

  onSaveInvoice(model: Invoice) {
    
    const fCtrl = (<any>this.myForm);
    this.loadingIndicator = true;
    const invoiceData = {
      jobs: model['jobs'],
      demurrage: model['demurrage'],
      toll_cost: model['toll_cost'],
      subtotal: model['subtotal'],
      gst: model['gst'],
      grand_total: model['grand_total']
    };

    //console.log('form', model);
    this.createInvoice(model);

  }

  created_invoice_id: number;
  createInvoice(invoiceData: Invoice) {
    this.http
      .post(this.url.rest + '/tms/saveInvoiceData', invoiceData)
      .subscribe(savedInvoice => {
        this.http.post(this.url.rest + '/tms/createInvoice', savedInvoice, { responseType: 'json' }).subscribe(res => {
          console.log('SAVE RESULT FROM INVOICE FILE', res);
          this.created_invoice_id = res['invoice'].id;
          //console.log(this.created_invoice_id, 'invoice_id');

          if(this.created_invoice_id){
            this.svc_toaster.showSuccess('Successfully created invoice, now redirecting to send invoice...', 'Create Invoice successful')
            this.showInvoiceEmailPage();
          }else{
            this.svc_toaster.showError('There was an error in creating invoice.', 'Create Invoice error')
          };

        });

        setTimeout(() => { this.loadingIndicator = false; }, 1000);
      });
  }

  showInvoiceEmailPage(){
    this.router.navigate(['invoices/email/' + this.created_invoice_id]);
  }

  async cancelJob(job_id){
    this.spinner = true;
    await this.bookingsService.cancelJob(job_id).toPromise().then(data => {
      //console.log(data)
      if(data['error']==false){
        this.toastr.success(data['message'], "", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
        if (this.dateDropdown == 'range') {
          this.processDateRange();
        } else this.getConnotes();
      }else{
        this.toastr.error("", data['message'], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
    });
    this.spinner = false;
    this.modalRef.close();

  }
  // end invoice immediate create in accept and send


  public control_no: string = '';
  public job_to_cancel: number;
  openModalCancelJob(job): void {
    this.control_no = job.control_no;
    this.job_to_cancel = job.id;
    this.modalRef = this.modal.open(this.modalCancelJob,{container: '.app', backdrop: 'static', size:'sm'});
  }

  public onMarkJobForInvoicing(id: number): void {
    this.loadingIndicator = true;
    this.http.get(this.url.rest + '/tms/markJobForInvoicing/' + id + '/' + this.user.id).subscribe(data => {
        this.toastr.success('', data["results"], {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      setTimeout(() => { this.loadingIndicator = false; });
      //console.log(data);
      
    }, error=>{
      this.toastr.error("Please try again.", "There was a problem with marking the selected job for invoicing", {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true
      });
    });
    if (this.dateDropdown == 'range') {
      this.processDateRange();
    } else this.getConnotes();
    this.modalRef.close();

  }

  getPrice(row) {
    // console.log('ROW', row);
    
    if(row.price >0){
      if (row.charging_method_id == '1') {
        if (row.tonnes && row.tonnes > 0)
          return row.tonnes * row.price;
        else return row.price;
      }
      else if (row.charging_method_id == '2') {
        if (row.pallet && row.pallet > 0)
          return row.pallets * row.price;
        else return row.price;
      }
      else if (row.charging_method_id == '3') {
        if (row.loads && row.loads > 0)
          return row.loads * row.price;
        else return row.price;
      }
      else if (row.charging_method_id == '4') {
        if (row.est_total_hours && row.est_total_hours > 0)
          return row.est_total_hours * row.price;
        else return row.price;
      }
      else if (row.charging_method_id == '5') {
        if (row.total_klms && row.total_klms > 0)
          return row.total_klms * row.price;
        else return row.price;
      }
    }else return "UNKNOWN PRICE";
  }

  
  toggleExpandRow(row) {
    console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event) {
    console.log('toggle detail');
  }

  isEnabled(name){
		let is_enabled = false;
		is_enabled = this.svc_components.isComponentEnabled(name);
		return is_enabled
	}

}
